


















import { Component, Vue } from 'vue-property-decorator'
import BaseLogo from '@/components/reusable-components/typography/BaseLogo.vue'
import AuthHeaderLayout from '@/components/layout/auth/AuthHeaderLayout.vue'
import AuthFooterLayout from '@/components/layout/auth/AuthFooterLayout.vue'

@Component({
    components: { AuthFooterLayout, AuthHeaderLayout, BaseLogo },
})
export default class AuthLayoutMondrian extends Vue {
    publicHomeUrl = process.env.VUE_APP_SPA2_BASE_URL as string
}
